// extracted by mini-css-extract-plugin
export var optionGrid = "_47-7";
export var optionList = "_47-6";
export var questionsBlock = "_47-9";
export var spacer = "_47-5";
export var stepCenteredContent = "_47-3";
export var stepInner = "_47-0";
export var stepInnerFullWidth = "_47-1";
export var stepInnerLockScroll = "_47-2";
export var stepTransitionFrame = "_47-4";
export var welcomeBlock = "_47-8";